import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/contratos/listar/form_edit'
import Head from '../../../../components/head'


function EditarContratoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Contrato" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarContratoScreen;